/**
 * WHERE YOU WERE HIT — keyed by the zone the AUTHORITY scores (`shooting-sim/targets.ts`).
 *
 * The key is the authority's and the words live here, not there: the engine is the generated copy of
 * the SIM and is not touched (§B.1), and a zone is a fact of the world while "chest" is a word for a
 * person. An unknown key falls back to itself — `arm_l`, ugly and true — rather than vanishing, because a
 * sign that omits where you were hit is lying by omission about the one thing it exists to say.
 */
export default {
  head: 'head',
  chest: 'chest',
  groin: 'hip',
  leg_l: 'left leg',
  leg_r: 'right leg',
  legs: 'legs',
  arm_l: 'left arm',
  arm_r: 'right arm',
};
